import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class SensorPresenter extends EntityPresenter {
  static urn = 'sensors'
  static key = 'sensor'

  static interval(id, interval) {
    return this.post(`${ id }/set-interval`, interval)
  }

  static updateStatus(id, status) {
    return this.patch(`update-status${ { id } }`, { status })
  }

  static navOptions(key = 'sensors') {
    const routes = {
      sensors: {
        icon: 'sensors',
        pageRoutes: ['sensor'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(SensorPresenter)
